import React, { useState, useEffect } from "react";
// utils
import FormButton from "../../button/FormButton";
import CommonForm from "../CommonForm";
import { FormikTextInput } from "../../inputs/FormikInputs";
// functions
import { postCondicion, deleteCondicion, updateCondicion } from './CondicionesAFIPFunctions';
import { handleResponse } from "../../../../services/Local-services";
// validaciones
import { formikValidation } from './CondicionesAFIPFormValidaciones';
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userCredentials, formIsOpen, rowSelected, snackbarData, formData } from '../../../../recoilState/GlobalState';

export default function CondicionesAFIPForm(props) {
    const [newCondicion, setNewCondicion] = useState({});
    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const [selected, setSelected] = useRecoilState(rowSelected);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { titles, updateList, procede } = props.props;

    async function handleAction() {
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        if (procede === 'Deleteone') {
            const response = await deleteCondicion(credentials, selected.row, setInRequest);
            return handleResponse(response, 'Condicion AFIP eliminada exitosamente', functions);
        }
        if (procede === 'Addone') {
            const response = await postCondicion(credentials, newCondicion, setInRequest)
            return handleResponse(response, 'Condicion AFIP añadida exitosamente', functions);
        }
        if (procede === 'Editone') {
            const response = await updateCondicion(credentials, newCondicion, selected.row, setInRequest)
            return handleResponse(response, 'Condicion AFIP modificada exitosamente', functions);
        }
    };

    useEffect(() => {
        if (procede !== 'Deleteone') handleAction();
    }, [newCondicion])

    const formik = formikValidation(setNewCondicion, selected.row, titles);
    const disabled = inRequest || procede === 'Deleteone';

    return (
        <CommonForm
            onSubmit={formik.handleSubmit}
            title={data.title}
            procede={procede}
        >
            <FormikTextInput
                data={data}
                name="nombre"
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name="codigo"
                formik={formik}
                disabled={disabled}
            />
            <FormikTextInput
                data={data}
                name="nombreAFIP"
                formik={formik}
                disabled={disabled}
            />
            <FormButton
                inRequest={inRequest}
                handleAction={handleAction}
            />
        </CommonForm>
    );
};